import React, { useState } from 'react';
import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../helpers/showMessage';
import Icon from 'lqa-ui/lib/Components/Icon';
import { useNavigate } from 'react-router-dom';
import { profileForgotpasswordUpdate } from './../../requests/authentication';
import { removeItem } from '../../utils/localStorage';
import { NotLoggedInHeader } from './../../app/common/sharedComponents/NotLoggedInHeader';
import { SPECIAL_CHARACTERS_REGEX, PASSWORD_REGEX_MIN_8_WITH_NUMBER } from '../../utils/regex';
import {
  InputContainer,
  Input,
  ForgotPasswordContainer,
  SubTitle,
  IconContainer,
  ButtonBlockColumn,
} from './ForgotPasswordChange.styled';
import { Body4 } from './../../app/common/typography';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';

const ForgotPasswordChange = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pin, setPin] = useState<string[]>(Array(6).fill(''));
  const errorStatus = false;

  const handleChangeInput = (e, index) => {
    setPin([...pin.map((d, i) => (i === index ? e.value : d))]);
    // Focus Previous
    if (e.value === '') {
      if (e.previousSibling && e.previousSibling instanceof HTMLInputElement) {
        e.previousSibling.focus();
      }
      return false;
    }
    // Focus Next
    if (e.nextSibling && e.nextSibling instanceof HTMLInputElement) {
      e.nextSibling.focus();
    }
    return false;
  };

  const handleSubmit = () => {
    const pincode = pin.join('').toLowerCase();
    if (pincode.length !== 6) {
      showErrorMessage('Please enter new pin code');
      return;
    }
    if (!(password === confirmPassword)) {
      showErrorMessage('Please Check your Password');
      return;
    } else if (!SPECIAL_CHARACTERS_REGEX.test(password)) {
      showErrorMessage('It is mandatory to have at least one of the following Special Characters: !@#$%^&*(),.?":{}|<>');
      return;
    } else if (!PASSWORD_REGEX_MIN_8_WITH_NUMBER.test(password)) {
      showErrorMessage('It is mandatory to have minimum 8 characters with at least one numnber');
      return;
    }
    const payload = { password, token: pincode };
    profileForgotpasswordUpdate(payload)
      .then(() => {
        showSuccessMessage('Password Updated Successfully');
        removeItem('email');
        navigate('/forgotpasswordsuccess');
      })
      .catch(() => {
        showErrorMessage('Verification code invalid or expired. Please try again.');
      });
  };
  const handlePasteCode = (e, index) => {
    e.preventDefault();
    if (index === 0) {
      const clipboardData = e.clipboardData || (window as any).clipboardData;
      const pastedText = clipboardData.getData('text');

      setPin((prevPin) => {
        const newHotelPin = [...prevPin];
        newHotelPin.splice(
          index,
          pastedText.length,
          ...pastedText.substring(0, 6).toUpperCase().split('')
        );
        return newHotelPin;
      });
    }
  };
  return (
    <>
      <NotLoggedInHeader />
      <ForgotPasswordContainer>
        <SubTitle>Please enter in your code</SubTitle>
        <InputContainer>
          {pin.map((data, index) => {
            return (
              <Input
                type="text"
                maxLength="1"
                key={index}
                value={data.toUpperCase()}
                onChange={(e) => handleChangeInput(e.target, index)}
                onFocus={(e) => e.target.select()}
                errorStatus={errorStatus}
                onPaste={(e) => handlePasteCode(e, index)}
              />
            );
          })}
        </InputContainer>
        <ControlInput
          label="New Password"
          name="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          required={true}
          hasError={false}
          disabled={false}
          secureTextEntry={true}
          revealPasswordAddOn={true}
        />
        <ControlInput
          label="Confirm Password"
          name="confirmPassword"
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value);
          }}
          required={true}
          hasError={false}
          disabled={false}
          secureTextEntry={true}
          revealPasswordAddOn={true}
        />
        <IconContainer>
          <Icon
            kind={PASSWORD_REGEX_MIN_8_WITH_NUMBER.test(password) ? 'status-success' : 'clear'}
            width={13}
            height={13}
          />
          <Body4 color="platinumDark">
            Password should be at least 8 Character long and Numbers
          </Body4>
        </IconContainer>
        <IconContainer>
          <Icon
            kind={SPECIAL_CHARACTERS_REGEX.test(password) ? 'status-success' : 'clear'}
            width={13}
            height={13}
          />
          <Body4 color="platinumDark">
            Special Characters - !@#$%^&*(),.?":{}|&lt;&gt;
          </Body4>
        </IconContainer>
        <IconContainer>
          <Icon
            kind={
              password && password === confirmPassword
                ? 'status-success'
                : 'clear'
            }
            width={13}
            height={13}
          />
          <Body4 color="platinumDark"> Password Must Match </Body4>
        </IconContainer>
        <ButtonBlockColumn>
          <ButtonLarge title="Reset Password" onClick={() => handleSubmit()} />
        </ButtonBlockColumn>
      </ForgotPasswordContainer>
    </>
  );
};

export default ForgotPasswordChange;
